export default function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/classCallCheck.js
// module id = 888
// module chunks = 0